<div class="error-page">
  <div class="error-page__logo">
    <img src="assets/img/logo-veolia.png" alt="Logo Veolia" />
  </div>
  <div>
    <h2 class="error-page__title">Une erreur technique est survenue</h2>
  </div>
  <p class="error-page__message">
    Veuillez nous en excuser. Nous vous invitons à fermer l'onglet du service et réessayer
    ultérieurement.
  </p>
  <div class="error-page__actions">
    <a class="btn btn-primary" [routerLink]="['/']">Retour à la page d'accueil</a>
  </div>
</div>
